import EditIcon from "@redotech/redo-icons/edit-02.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.orderNote;

export const OrderNoteFilter: AdvancedTableFilter = {
  type: entry.type,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.IS_NOT_EMPTY,
  },
  itemLabel: "note",
  Icon: EditIcon,
  values: [],
  displayName: entry.displayName,
};
